<template>
  <MainLayout>
    <template v-slot:toolbar>
      <!--begin::Page title-->
      <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
        <!--begin::Title-->
        <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Histórico de alterações</h1>
        <!--end::Title-->
        <div class="mt-3" v-if="filteredChangeHistory.length > 0">
          <p class="mb-0">
            <strong>Resultados:</strong> {{ filteredChangeHistory.length }}/{{ total }}
          </p>
        </div>
      </div>
      <!--begin::Actions-->
      <div class="d-flex align-items-center gap-2 gap-lg-3 position-relative">
        <!--begin::Filter menu-->
        <div class="m-0">
          <!--begin::Menu toggle-->
          <a
            href="#"
            @click.prevent="isFiltersOpen = !isFiltersOpen"
            class="btn btn-sm btn-flex bg-body btn-color-gray-700 btn-active-color-primary fw-bold"
          >
          <!--begin::Svg Icon | path: icons/duotune/general/gen031.svg-->
          <span class="svg-icon svg-icon-6 svg-icon-muted me-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z" fill="currentColor" />
            </svg>
          </span>
          <!--end::Svg Icon-->Filtrar</a>
          <!--end::Menu toggle-->
          <!--begin::Menu 1-->
          <div
            class="menu menu-sub menu-sub-dropdown w-250px w-md-700px filter-dropdown-menu"
            :class="{
              'show': isFiltersOpen
            }"
          >
            <!--begin::Header-->
            <div class="px-7 py-5">
              <div class="fs-5 text-dark fw-bold">Opções de Filtro</div>
            </div>
            <!--end::Header-->
            <!--begin::Menu separator-->
            <div class="separator border-gray-200"></div>
            <!--end::Menu separator-->
            <!--begin::Form-->
            <div class="px-7 py-5 d-flex gap-7">
              <div class="col-5">
                <!--begin::Input group-->
                <div class="mb-5">
                  <!--begin::Label-->
                  <label class="form-label fw-semibold">Busca:</label>
                  <p class="search-hint">ID, entidade, usuário ou ação)</p>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <div>
                    <input type="text" class="form-control form-control-solid" placeholder="" v-model.trim="tempFilters.search"/>
                  </div>
                  <!--end::Input-->
                </div>
                <!--end::Input group-->
                <!--begin::Input group-->
                <div class="mb-5">
                  <!--begin::Label-->
                  <label class="form-label fw-semibold">Tipo de entidade:</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <div>
                    <select class="form-select" aria-label="Select example" v-model="tempFilters.entity_type">
                      <option value="">Todos</option>
                      <option value="ADVERTISER">Anunciante</option>
                      <option value="COMPANY">Empresa</option>
                      <option value="CAMPAIGN">Campanha</option>
                      <option value="CAMPAIGN_PACKAGE">Grupo de Campanha</option>
                      <option value="CAMPAIGN_LINE">Estratégia</option>
                      <option value="CREATIVE">Criativo</option>
                      <option value="ORDER">Order</option>
                      <option value="INSERTION_ORDER">P.I.</option>
                      <option value="PIXEL">Pixel</option>
                      <option value="REPORT">Relatório</option>
                    </select>
                  </div>
                  <!--end::Input-->
                </div>
                <!--end::Input group-->
                <!--begin::Input group-->
                <div class="mb-5">
                  <!--begin::Label-->
                  <label class="form-label fw-semibold">Ação:</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <div>
                    <select class="form-select" aria-label="Select example" v-model="tempFilters.action">
                      <option value="">Todas</option>
                      <option value="CREATE">Criado</option>
                      <option value="APPROVE">Aprovado</option>
                      <option value="UPDATE">Atualizado</option>
                      <option value="REPLICATE">Replicado</option>
                      <option value="ISSUE">Emitido</option>
                      <option value="DESTROY">Apagado</option>
                      <option value="CANCEL">Cancelado</option>
                    </select>
                  </div>
                  <!--end::Input-->
                </div>
                <!--end::Input group-->
              </div>
              <div class="">
                <!--begin::Input group-->
                <div class="mb-5">
                  <!--begin::Label-->
                  <label class="form-label fw-semibold">Data de início:</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <div>
                    <div class="d-flex align-items-start justify-content-between">
                      <div class="">
                        <input class="form-control form-control-solid date_picker_date" v-model.trim="tempFilters.start_date" />
                        <div class="mt-3">
                          <button type="button" class="btn btn-sm btn-primary" @click="tempFilters.start_date = ''" v-if="tempFilters.start_date">Limpar</button>
                        </div>
                      </div>
                      <div class="px-4 mt-4">-</div>
                      <div class="">
                        <input class="form-control form-control-solid date_picker_date" v-model.trim="tempFilters.end_date" />
                        <div class="mt-3">
                          <button type="button" class="btn btn-sm btn-primary" @click="tempFilters.end_date = ''" v-if="tempFilters.end_date">Limpar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end::Input-->
                </div>
                <!--end::Input group-->
              </div>
            </div>
            <!--begin::Actions-->
            <div class="d-flex justify-content-end pb-5 pe-7">
              <button type="reset" class="btn btn-sm btn-light btn-active-light-primary me-2" data-kt-menu-dismiss="true" @click="reset">Resetar</button>
              <button type="submit" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true" @click="applyFilters">Aplicar</button>
            </div>
            <!--end::Actions-->
            <!--end::Form-->
          </div>
          <!--end::Menu 1-->
        </div>
        <!--end::Filter menu-->
      </div>
      <!--end::Actions-->
      <!--end::Page title-->
    </template>

    <!-- CONTENT -->
    <!--begin::Card-->
    <div class="card card-flush">
      <!--begin::Card header-->
      <div class="card-header align-items-center py-5 gap-2 gap-md-5"></div>
      <!--end::Card header-->

      <!--begin::Card body-->
      <div class="card-body pt-0">
        <!--begin::Navigation buttons-->
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
          <div class="d-flex flex-wrap gap-2">
            <span
              v-for="button in navigationButtons"
              :key="button.type"
              v-b-tooltip.hover
              :title="getTabTooltip(button.type)"
              class="d-inline-block"
            >
              <button
                @click="filterByEntityType(button.type)"
                :class="['btn', button.class, getButtonClass(button.type)]"
                :disabled="isTabDisabled(button.type)"
                style="pointer-events: auto;"
              >
                <i :class="button.icon"></i>
                {{ button.label }}
              </button>
            </span>
          </div>
        </div>
        <!--begin::Order by select-->
        <div class="d-flex align-items-center gap-2 my-10">
          <label class="form-label mb-0 text-muted fw-semibold fs-7">Ordenar:</label>
          <select
            class="form-select form-select-sm w-auto"
            v-model="clientSortOrder"
            @change="applyClientSideFilters"
          >
            <option value="desc">Mais recentes</option>
            <option value="asc">Mais antigos</option>
          </select>
        </div>
        <!--end::Order by select-->
        <!--end::Navigation buttons-->

        <template v-if="loader && filteredChangeHistory.length === 0">
          <div class="py-5">
            <Loader size="big" />
          </div>
        </template>
        <template v-else-if="!loader && filteredChangeHistory.length === 0">
          <p class="text-center pt-5">Nenhum histórico encontrado</p>
        </template>
        <template v-else>
          <div class="table-responsive">
            <!--begin::Table-->
            <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_change_history_table">
              <!--begin::Table head-->
              <thead>
                <!--begin::Table row-->
                <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                  <th class="min-w-100px">Data</th>
                  <th class="min-w-100px">Tipo</th>
                  <th class="min-w-200px">Título</th>
                  <th class="min-w-100px">Ação</th>
                  <th class="min-w-100px">Usuário</th>
                  <th class="min-w-100px">Ações</th>
                </tr>
                <!--end::Table row-->
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody class="fw-semibold text-gray-600">
                <!--begin::Table row-->
                <tr v-for="(history, index) in filteredChangeHistory" :key="index">
                  <!-- date -->
                  <td>
                    <span>{{ history.created_at | formatDate('DD/MM/YYYY HH:mm:ss') }}</span>
                  </td>
                  <!-- log type -->
                  <td>
                    <span class="badge" :class="getEntityTypeBadgeClass(history.loggable_type)">
                      {{ $options.filters.formatEntityNames(history.loggable_type) }}
                    </span>
                  </td>
                  <!-- title -->
                  <td>
                    <a :href="formatRedirectableUrl(history.loggable)" target="_blank" rel="noopener noreferrer">{{ history.loggable?.name || "N/A" }}</a>
                  </td>
                  <!-- action -->
                  <td>
                    <span class="badge" :class="getActionBadgeClass(history.type)">
                      {{ formatChangeAction(history) }}
                    </span>
                  </td>
                  <!-- user -->
                  <td>
                    <a :href="'users/' + history.user.id" target="_blank"> {{ history.user_name || 'Sistema' }} </a>
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'change-history.show', params: { uuid: history.uuid } }"
                      class="btn btn-sm btn-light btn-active-light-primary"
                      v-if="history.uuid"
                    >
                      <i class="fas fa-eye"></i>
                      Ver Detalhes
                    </router-link>
                    <span v-else class="text-muted">N/A</span>
                  </td>
                </tr>
                <!--end::Table row-->
              </tbody>
              <!--end::Table body-->
            </table>
          </div>
          <!--end::Table-->
          <div class="text-center py-5">
            <Button
              class="btn-primary"
              :loading="loader"
              @click="loadMore"
              v-if="isLoadMoreVisible"
            >
              Carregar mais
            </Button>
          </div>
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Card-->
    <!-- END CONTENT -->
  </MainLayout>
</template>

<script>

import ChangeHistoryService from '@/modules/change-history/services/change-history-service'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'

export default {
  components: {
    Button,
    Loader,
    MainLayout
  },
  metaInfo () {
    return {
      title: 'Histórico de alterações'
    }
  },
  data () {
    return {
      changeHistory: [], //  all data loaded from backend on first request
      filteredChangeHistory: [], // filtered data on client-side
      currentTab: 'history',
      filters: {
        search: '',
        entity_type: '',
        action: '',
        start_date: '',
        end_date: '',
        order_by: 'desc'
      },
      tempFilters: { // modal filters
        search: '',
        entity_type: '',
        action: '',
        start_date: '',
        end_date: ''
      },
      //  client-side filters (tabs)
      clientEntityTypeFilter: '',
      clientSearchTerm: '',
      clientSortOrder: 'desc',
      navigationButtons: [
        { type: 'all', label: 'Todos os Tipos', icon: 'fas fa-list', class: 'btn-sm' },
        { type: 'ADVERTISER', label: 'Anunciante', icon: 'fas fa-user', class: 'btn-sm' },
        { type: 'CAMPAIGN', label: 'Campanha', icon: 'fas fa-bullhorn', class: 'btn-sm' },
        { type: 'CAMPAIGN_PACKAGE', label: 'Grupo de Campanha', icon: 'fas fa-layer-group', class: 'btn-sm' },
        { type: 'CAMPAIGN_LINE', label: 'Estratégia', icon: 'fas fa-chess', class: 'btn-sm' },
        { type: 'CREATIVE', label: 'Criativo', icon: 'fas fa-paint-brush', class: 'btn-sm' },
        { type: 'ORDER', label: 'Order', icon: 'fas fa-shopping-cart', class: 'btn-sm' },
        { type: 'INSERTION_ORDER', label: 'P.I.', icon: 'fas fa-file-invoice', class: 'btn-sm' },
        { type: 'PIXEL', label: 'Pixel', icon: 'fas fa-code', class: 'btn-sm' },
        { type: 'REPORT', label: 'Relatório', icon: 'fas fa-file-invoice', class: 'btn-sm' },
        { type: 'COMPANY', label: 'Empresa', icon: 'fas fa-building', class: 'btn-sm' }
      ],
      isFiltersOpen: false,
      isLoadMoreVisible: false,
      loader: false,
      page: 1,
      searchTimeout: null,
      total: 0
    }
  },
  computed: {
    /**
     * If other filters are active in modal (other than entity), disable tabs
     */
    hasOtherFiltersActive () {
      return !!(
        this.filters.search ||
        this.filters.action ||
        this.filters.start_date ||
        this.filters.end_date
      )
    }
  },
  created () {
    this.getChangeHistory()
  },
  mounted () {
    document.getElementsByClassName('date_picker_date').forEach(item => {
      item.flatpickr({
        dateFormat: 'd/m/Y'
      })
    })
  },
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        this.reset()
      }
    }
  },
  methods: {
    /**
     * Get tooltip text
     */
    getTabTooltip (buttonType) {
      return ''
    },
    /**
     * Apply filters from modal (makes backend request)
     */
    applyFilters () {
      this.filters.search = this.tempFilters.search
      this.filters.entity_type = this.tempFilters.entity_type
      this.filters.action = this.tempFilters.action
      this.filters.start_date = this.tempFilters.start_date
      this.filters.end_date = this.tempFilters.end_date

      // Sync tabs with modal filter
      if (this.filters.entity_type) {
        this.clientEntityTypeFilter = this.filters.entity_type
      } else {
        this.clientEntityTypeFilter = ''
      }

      this.isFiltersOpen = false
      this.page = 1
      this.changeHistory = []
      this.filteredChangeHistory = []

      this.getChangeHistory()
    },
    /**
     * Apply client-side filters (no backend request) from tabs
     */
    applyClientSideFilters () {
      let filtered = [...this.changeHistory]

      if (this.clientSearchTerm) {
        const searchLower = this.clientSearchTerm.toLowerCase()
        filtered = filtered.filter(item => {
          const name = (item.loggable?.name || '').toLowerCase()
          const userName = (item.user_name || '').toLowerCase()
          const entityType = (item.loggable_type || '').toLowerCase()
          const action = this.formatChangeAction(item).toLowerCase()

          return name.includes(searchLower) ||
                 userName.includes(searchLower) ||
                 entityType.includes(searchLower) ||
                 action.includes(searchLower)
        })
      }

      // sorting
      filtered.sort((a, b) => {
        const dateA = new Date(a.created_at)
        const dateB = new Date(b.created_at)
        return this.clientSortOrder === 'desc' ? dateB - dateA : dateA - dateB
      })

      this.filteredChangeHistory = filtered
    },
    /**
     * Filter by entity type (makes backend request)
     */
    filterByEntityType (entityType) {
      if (entityType === 'all') {
        this.clientEntityTypeFilter = ''
        this.filters.entity_type = ''
      } else {
        this.clientEntityTypeFilter = entityType
        this.filters.entity_type = entityType
      }

      // Reset pagination and data
      this.page = 1
      this.changeHistory = []
      this.filteredChangeHistory = []

      // Make backend request with new entity type
      this.getChangeHistory()
    },
    /**
     * Verify if tab should be disabled
     */
    isTabDisabled (buttonType) {
      return false
    },
    /**
     * Return redirect url to entity show page
     */
    formatRedirectableUrl (loggable) {
      if (!loggable) return null
      const entityType = loggable.type || loggable.loggable_type

      let routeName = null
      const queryParams = {}

      if (['CAMPAIGN', 'CAMPAIGN_LINE', 'CAMPAIGN_PACKAGE'].includes(entityType)) {
        routeName = 'campaigns.show'

        // Automatic scroll and tab selection based on entity type
        if (entityType === 'CAMPAIGN_PACKAGE') {
          queryParams.section = 'packages'
        } else if (entityType === 'CAMPAIGN_LINE') {
          queryParams.section = 'campaign_line'
        }
      } else {
        switch (entityType) {
          case 'ADVERTISER':
            routeName = 'advertisers.show'
            break
          case 'CREATIVE':
            routeName = 'creatives.show'
            break
          default:
            return null
        }
      }

      if (routeName && loggable.uuid) {
        const route = {
          name: routeName,
          params: { id: loggable.campaign_id ?? loggable.uuid }
        }

        // Add query params if any
        if (Object.keys(queryParams).length > 0) {
          route.query = queryParams
        }

        return this.$router.resolve(route).href
      }

      return null
    },
    /**
     * Get action badge class
     */
    getActionBadgeClass (action) {
      return {
        'badge-success': action.includes('CREATE') || action.includes('ACTIVATE') || action.includes('APPROVE') || action.includes('ISSUE'),
        'badge-warning': action.includes('UPDATE') || action.includes('ADD_COUPON'),
        'badge-danger': action.includes('DESTROY') || action.includes('PAUSE') || action.includes('CANCEL'),
        'badge-info': action.includes('IMPORT') || action.includes('REPLICATE') || action.includes('IMPERSONATE') || action.includes('DOWNLOAD')
      }
    },
    /**
     * Get button class based on selection state
     */
    getButtonClass (buttonType) {
      if (buttonType === 'all') {
        return this.clientEntityTypeFilter === '' ? 'btn-primary' : 'btn-light'
      } else {
        return this.clientEntityTypeFilter === buttonType ? 'btn-primary' : 'btn-light'
      }
    },
    /**
     * Get change history from backend from modal Filters
     */
    async getChangeHistory () {
      this.loader = true
      try {
        // Construct params object dynamically, only including non-empty values
        const params = {
          page: this.page
        }

        // using modal filters
        if (this.filters.search) {
          params.search = this.filters.search
        }
        if (this.filters.entity_type) {
          params.loggable_type = this.filters.entity_type
        }
        if (this.filters.action) {
          params.action = this.filters.action
        }
        if (this.filters.start_date) {
          params.start_date = this.filters.start_date
        }
        if (this.filters.end_date) {
          params.end_date = this.filters.end_date
        }
        if (this.filters.order_by) {
          params.order_by = this.filters.order_by
        }

        const response = await ChangeHistoryService.getChangeHistory(params)
        const data = response.data || response
        this.changeHistory = [...this.changeHistory, ...data]
        this.isLoadMoreVisible = response.meta ? response.meta.current_page !== response.meta.last_page : false
        this.total = response.meta ? response.meta.total : data.length

        this.applyClientSideFilters()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Get entity type badge class
     */
    getEntityTypeBadgeClass (entityType) {
      return {
        'badge-primary': entityType === 'ADVERTISER',
        'badge-info': entityType === 'CAMPAIGN',
        'badge-secondary': entityType === 'CAMPAIGN_PACKAGE',
        'badge-warning': entityType === 'CAMPAIGN_LINE',
        'badge-success': entityType === 'CREATIVE',
        'badge-dark': entityType === 'CUSTOM_TARGETING',
        'badge-light': entityType === 'USER' || entityType === 'COMPANY',
        'badge-danger': entityType === 'ORDER' || entityType === 'REPORT',
        'badge-warning text-dark': entityType === 'INSERTION_ORDER' || entityType === 'PIXEL'
      }
    },
    /**
     * Load more keeping modal filters
     */
    loadMore () {
      this.page++
      this.getChangeHistory()
    },
    formatChangeAction (change) {
      let verb
      if (change.type.includes('CREATE')) {
        verb = 'Criou'
      } else if (change.type.includes('UPDATE')) {
        verb = 'Atualizou'
      } else if (change.type.includes('DESTROY') || change.type.includes('DELETE')) {
        verb = 'Excluiu'
      } else if (change.type.includes('IMPORT')) {
        verb = 'Importou'
      } else if (change.type.includes('ACTIVATE')) {
        verb = 'Ativou'
      } else if (change.type.includes('PAUSE')) {
        verb = 'Pausou'
      } else if (change.type.includes('IMPERSONATE')) {
        verb = 'Usou o impersonate'
      } else if (change.type.includes('REPLICATE')) {
        verb = 'Replicou'
      } else if (change.type.includes('APPROVE')) {
        verb = 'Aprovou'
      } else if (change.type.includes('ISSUE')) {
        verb = 'Emitiu'
      } else if (change.type.includes('CANCEL')) {
        verb = 'Cancelou'
      } else if (change.type.includes('DOWNLOAD')) {
        verb = 'Baixou NFSe'
      } else if (change.type.includes('ADD_COUPON')) {
        verb = 'Adicionou cupom ao'
      }

      return verb + ' ' + this.$options.filters.formatEntityNames(change.loggable_type)
    },
    /**
     * Reset all filters
     */
    reset (reload = false) {
      this.isFiltersOpen = false

      // Reset Modal filter
      this.filters.search = ''
      this.filters.entity_type = ''
      this.filters.action = ''
      this.filters.start_date = ''
      this.filters.end_date = ''
      this.filters.order_by = 'desc'

      this.tempFilters.search = ''
      this.tempFilters.entity_type = ''
      this.tempFilters.action = ''
      this.tempFilters.start_date = ''
      this.tempFilters.end_date = ''

      // Reset CLIENT-SIDE filters ( tabs)
      this.clientEntityTypeFilter = ''
      this.clientSearchTerm = ''
      this.clientSortOrder = 'desc'

      // Reset sort and pagination
      this.page = 1
      this.changeHistory = []
      this.filteredChangeHistory = []

      // new request with no filters
      this.getChangeHistory()
    }
  }
}
</script>

<style scoped>
.filter-dropdown-menu {
  position: absolute;
  top: 40px;
  right: 0;
}

.search-hint {
  font-size: 11px;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
